/**
 * 業務マスタ → コンボボックス候補 の変換
 * 設計: docs/design/work-item-picker-ux.md §6.2
 *  - 単価を必ず候補に出す（D5）
 *  - 束（default_items が 2 件以上）は行数バッジ + 内訳プレビュー（D3/D5）
 */
import type { ComboboxOption } from "../ui/WorkItemCombobox.js";
import type { WorkItemMaster } from "../../api/workItemMasterApi.js";
import type { WorkItemInput } from "../../api/workItemsApi.js";
import { PROFESSION_LABEL, PROFESSION_COLOR } from "../../lib/workItemConstants.js";

/** マスタ明細 1 件の金額（amount が無ければ 数量 × 単価） */
export function masterItemAmount(item: WorkItemInput): number {
  if (item.amount !== undefined && item.amount !== null) return item.amount;
  return Math.floor((item.quantity ?? 1) * (item.unit_price ?? 0));
}

/** 単一明細マスタなら明細を返す。束なら undefined */
export function singleItemOf(master: WorkItemMaster): WorkItemInput | undefined {
  const items = master.default_items ?? [];
  return items.length === 1 ? items[0] : undefined;
}

export function masterToOption(master: WorkItemMaster): ComboboxOption {
  const items  = master.default_items ?? [];
  const single = singleItemOf(master);
  const profession = single?.profession ?? master.profession;

  const metaParts: string[] = [];
  if (master.is_pinned) metaParts.push("★ よく使う");
  if (master.usage_count > 0) metaParts.push(`使用 ${master.usage_count} 回`);
  if (single && (single.quantity ?? 1) !== 1) metaParts.push(`数量 ${single.quantity}`);

  return {
    id:    master.id,
    // 単一明細マスタは明細のタイトルを正とする（設計 §6.7）
    label: single?.title || master.name,
    price: single ? masterItemAmount(single) : undefined,
    badge: PROFESSION_LABEL[profession] ?? profession,
    badgeColor: PROFESSION_COLOR[profession] ?? "#475569",
    meta:  metaParts.length > 0 ? metaParts.join(" / ") : undefined,
    bundleSize: items.length > 1 ? items.length : undefined,
    bundleItems: items.length > 1
      ? items.map((i) => ({ label: i.title, price: masterItemAmount(i) }))
      : undefined,
    keywords: [master.name, master.description ?? "", ...items.map((i) => i.title)].join(" "),
  };
}
